import * as actions from "./actions";
import { Action } from "redux";
import { isType } from "typescript-fsa";
import { SnackbarState, SnackbarTypes } from "./types";

const initialState: SnackbarState = {
  type: SnackbarTypes.success,
  message: "",
  open: false,
};

export const snackbarReducer = (
  state = initialState,
  action: Action
): SnackbarState => {
  if (isType(action, actions.showSuccessSnackbar)) {
    return {
      ...state,

      type: SnackbarTypes.success,
      message: action.payload,
      open: true,
    };
  }

  if (isType(action, actions.clearSnackbar)) {
    return {
      ...state,
      open: false,
    };
  }

  if (isType(action, actions.showErrorSnackbar)) {
    return {
      ...state,

      type: SnackbarTypes.error,
      message: action.payload,
      open: true,
    };
  }

  if (isType(action, actions.showWarningSnackbar)) {
    return {
      ...state,

      type: SnackbarTypes.warning,
      message: action.payload,
      open: true,
    };
  }

  if (isType(action, actions.showInfoSnackbar)) {
    return {
      ...state,

      type: SnackbarTypes.info,
      message: action.payload,
      open: true,
    };
  }

  return state;
};
